export default __webpack_public_path__ + "static/media/restaurant1.afcb046b.png";